export enum PromotionErrorExtensions {
  // server/app/schema/plugin/promotions.js
  PROMOTION_INVALID = 'PROMOTION_INVALID',
  PROMOTION_NOT_FOUND = 'PROMOTION_NOT_FOUND',
  PROMOTION_EXPIRED = 'PROMOTION_EXPIRED',
  PROMOTION_NOT_ELIGIBLE = 'PROMOTION_NOT_ELIGIBLE',
  PROMOTION_ALREADY_REDEEMED = 'PROMOTION_ALREADY_REDEEMED',
}

export const PromotionErrors: Record<string, PromotionErrorExtensions> = {
  'Not a valid promotion': PromotionErrorExtensions.PROMOTION_INVALID,
  'This promotion is no longer active':
    PromotionErrorExtensions.PROMOTION_EXPIRED,
  'This promotion is currently unavailable':
    PromotionErrorExtensions.PROMOTION_INVALID,
  'Cannot redeem discount': PromotionErrorExtensions.PROMOTION_NOT_ELIGIBLE,
  'Team is not eligible for discount':
    PromotionErrorExtensions.PROMOTION_NOT_ELIGIBLE,
};
